import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { FormComponent, RowComponent, FieldComponent } from '@src/app/components';

import { FormType } from './types';
import { MAPPING_VALUES } from '../mapping-form/constants';

@Component({
  selector: 'filter-param-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    TabViewModule,
    FormComponent,
    RowComponent,
    FieldComponent,
  ],
  templateUrl: './param-form.component.html',
  styleUrl: './param-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParamFormComponent {
  @Input() form!: FormGroup<FormType>;
  @Input() loading = false;

  readonly sources = MAPPING_VALUES;
}
